import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BreadCrump } from '../../shared/bread-crump/bread-crump';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, BreadCrump],
  template: `
    <app-bread-crump 
      [title]="'404'" 
      [description]="'الصفحة غير موجودة'"
      [items]="[{label: 'الرئيسية', url: '/'}]">
    </app-bread-crump>
    <div class="container py-5 text-center my-5">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
           style="width: 80px; height: 80px; color: #dc3545; margin-bottom: 1.5rem;">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <h2 class="mb-4 fw-bold">عفواً، هذه الصفحة غير موجودة أو الرابط غير صحيح.</h2>
      <p class="text-muted mb-4">يبدو أن الصفحة التي تبحث عنها قد تم إزالتها، أو تم تغيير اسمها، أو أنها غير متاحة مؤقتاً.</p>
      <a routerLink="/" class="btn btn-primary px-4 py-2" style="border-radius: 4px;">
        العودة إلى الصفحة الرئيسية
      </a>
    </div>
  `
})
export class NotFound {}
